import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ICouponDetail } from "src/models/Offers/Coupon.models";

interface CouponDetailState {
  couponDetails: ICouponDetail[];
  couponDetailToEdit: ICouponDetail | null;
}

const initialState: CouponDetailState = {
  couponDetails: [],
  couponDetailToEdit: null,
};

const CouponDetailSlice = createSlice({
  name: "CouponDetail",
  initialState,
  reducers: {
    setCouponDetailList: (state, action: PayloadAction<ICouponDetail[]>) => {
      state.couponDetails = action.payload;
    },
    concatListCouponDetail: (
      state: CouponDetailState,
      action: PayloadAction<ICouponDetail[]>
    ) => {
      state.couponDetails = [...state.couponDetails.concat(action.payload)];
    },
    setCouponDetailToEdit: (
      state,
      action: PayloadAction<ICouponDetail | null>
    ) => {
      state.couponDetailToEdit = action.payload;
    },
    addCouponDetail: (state, action: PayloadAction<ICouponDetail>) => {
      state.couponDetails.push(action.payload);
    },
    updateCouponDetail: (state, action: PayloadAction<ICouponDetail>) => {
      let itemIndex = state.couponDetails.findIndex(
        item => item.couponDetailId === action.payload.couponDetailId
      );
      if (itemIndex !== -1) state.couponDetails[itemIndex] = action.payload;
    },
    deleteCouponDetail: (state, action: PayloadAction<number>) => {
      const newArray = state.couponDetails.filter(
        item => item.couponDetailId !== action.payload
      );
      state.couponDetails = newArray;
    },
  },
});

export const {
  setCouponDetailList,
  concatListCouponDetail,
  setCouponDetailToEdit,
  addCouponDetail,
  updateCouponDetail,
  deleteCouponDetail,
} = CouponDetailSlice.actions;

export default CouponDetailSlice.reducer;
